<script setup>
import ToastDismissAll from '~/components/common/ToastDismissAll.vue'
import ErrorFlash from '~/components/app/ErrorFlash.vue'

// max=20: prevents a runaway loop of error toasts from flooding the UI.
// New toasts past the cap evict the oldest. duration is overridden per-toast
// in useNotifications.ts (success/info/warning: 10s, error: sticky).
//
// ui.viewport bottom-20 (5rem): lifts the toast stack to leave room for the
// ToastDismissAll pill at bottom-right (~3.5rem tall incl. spacing). Default
// is bottom-4 which lands the last toast directly on top of the pill.
const toaster = {
  max: 20,
  ui: { viewport: 'bottom-16' }
}
</script>

<template>
  <UApp :toaster="toaster">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ToastDismissAll />
    <!-- The red rim on a refused scan, raised from signalScanner('error') anywhere. -->
    <ErrorFlash />
  </UApp>
</template>
